export class InvalidEchoError extends Error {
  static message = "invalid-echo";

  static test(e: any) {
    if (!e) return false;
    return (e instanceof InvalidEchoError) || (e.message === InvalidEchoError.message);
  }

  constructor() {
    super(InvalidEchoError.message);
    Object.setPrototypeOf(this, InvalidEchoError.prototype);
  }

  get stack() {
    return undefined;
  }
}
